import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import {useAuthState} from 'react-firebase-hooks/auth';

const app = firebase.initializeApp({
      apiKey: "AIzaSyCz6bUWNihGuYnY4EDLzJSEfgEY9XckNNs",
      authDomain: "firechat-5265f.firebaseapp.com",
      projectId: "firechat-5265f",
      storageBucket: "firechat-5265f.appspot.com",
      messagingSenderId: "109837456459",
      appId: "1:109837456459:web:55ecc61f93d0693009e9ce"
})
const auth = firebase.auth();
const db = firebase.firestore(app);
export {app, auth, firebase, useAuthState, db}